
import { Grid } from "@mui/material";
import MultiImage from "../../attachedImage/multiImage";
import { IAttachedFile } from "./IAttachedFile";
import { useEffect, useState } from "react";
import { IFileResponse } from "../../../../../models/loan.model";
import FullScreenMultiImage from "../../attachedImage/fullScreenMultiImage";
import { useDispatch } from "react-redux";
import { changeRouteType, getpervInnerState } from "../../../../../redux/handleBackBtn/handleBackBtnSlice";
import { setHeaderTitle } from "../../../../../redux/headerTitle/headerTitleSlice";


export default function AttachedFile({ images, showFullAttachments }: IAttachedFile) {

    const [fullScreenFiles, setFullScreenFiles] = useState<IFileResponse[]>();



    // const showFullAttachments = (data: IFileResponse[]) => {
    //     setUserMultiImage(true);
    //     setFullScreenFiles(data);
    // }

    const dispatch = useDispatch();
    useEffect(() => {

        dispatch(
            setHeaderTitle({
                color: "var(--header-color)",
                header: 'تصاویر ضمیمه شده',
                parentRoute: 'handleloanDetail',
            })
        );
    }, [])

    return (
        <div className="p-5" style={{ marginTop: "20px" }} >
            {/* {userMultiImage == false ? */}
            <Grid container>
                {/* {(images != undefined && images.length > 0) ? */}
                {images?.map((item: any, index: any) => {
                    return (<MultiImage data={item.data} title={item.title} setUserMultiImage={showFullAttachments}></MultiImage>)
                })}
            </Grid >
            {/* :
                <FullScreenMultiImage data={fullScreenFiles}></FullScreenMultiImage>} */}

        </div>
    )
}